import React, { ReactElement, useEffect, useRef, useState } from 'react';
import { useParams, Redirect, Link } from 'react-router-dom';
import { API } from '../../../services/api';
import Loading from '../../../components/Loading';
import { registerLocale } from 'react-datepicker';
import 'react-datepicker/dist/react-datepicker.css';
import de from 'date-fns/locale/de';
import { HostInterface } from '../../../interfaces/HostInterface';
import { MediaDto } from '../../../interfaces/MediaDto';
import { Media } from '../../../interfaces/Media';

registerLocale('de', de);

export default (): ReactElement => {
  const [host, setHost] = useState<HostInterface>();
  const [redirect, setRedirect] = useState<boolean>(false);

  const [name, setName] = useState<string>('');
  const [bio, setBio] = useState<string>('');
  const [avatar, setAvatar] = useState<Media>();
  const [fileToUpload, setFileToUpload] = useState<MediaDto>();
  const [avatarPreview, setAvatarPreview] = useState<string>('');

  const { id }: any = useParams();

  const displayAvatar = () => {
    if (avatarPreview) {
      return <img src={avatarPreview} style={{ width: '100%' }} />;
    }
    if (avatar) {
      return <img src={avatar.link} style={{ width: '100%' }} />;
    }
    return <></>;
  };

  const readAsDataUrl = (file: File) => {
    let error;
    let fr = new FileReader();

    fr.onload = function () {
      if (fr.result) {
        setFileToUpload({
          label: file.name,
          data: fr.result.toString(),
        });
        setAvatarPreview(fr.result.toString());
      }
    };

    fr.onerror = function () {
      error = fr;
    };

    fr.readAsDataURL(file);
  };

  useEffect(() => {
    (async () => {
      const result = await API.get(`host/${id}`);
      setHost(result);
      setName(result.name);
      setBio(result.bio);
      setAvatar(result.avatar);
    })();
  }, []);

  const handleSave = async () => {
    await API.patch(`host/${id}`, {
      name,
      bio,
      avatar: fileToUpload,
    });
    setRedirect(true);
  };

  const inputAvatar = useRef(null);

  if (redirect) return <Redirect to={`/seminars/hosts`} />;

  if (!host) return <Loading />;

  return (
    <section className="content-header">
      <div className="container-fluid">
        <div className="row mb-2">
          <div className="col-sm-6">
            <h1>{name}</h1>
          </div>
          <div
            className="col-sm-6"
            style={{
              textAlign: 'right',
            }}
          >
            <Link to={`/seminars/hosts`}>
              <button type="button" className="btn btn-secondary btn-sm">
                Abbrechen
              </button>
            </Link>
            &nbsp; &nbsp; &nbsp;
            <button
              type="button"
              className="btn btn-primary btn-sm"
              onClick={handleSave}
            >
              Speichern
            </button>
          </div>
        </div>
        <div>
          <div className="card card-primary">
            <div className="card-body">
              <div className="form-group">
                <label>Avatar</label>
                <div
                  onClick={() => readAsDataUrl}
                  style={{
                    marginBottom: 10,
                    height: 80,
                    width: 80,
                    borderRadius: 200,
                    backgroundColor: '#6C757D',
                    display: 'flex',
                    justifyContent: 'center',
                    alignItems: 'center',
                    overflow: 'hidden',
                  }}
                >
                  {displayAvatar()}
                </div>
                <input
                  type="file"
                  ref={inputAvatar}
                  onChange={(e) => {
                    if (e.target.files) {
                      readAsDataUrl(e.target.files[0]);
                    }
                  }}
                />
              </div>
              <div className="form-group">
                <label>Name</label>
                <input
                  type="text"
                  className="form-control"
                  onChange={(e) => setName(e.target.value)}
                  value={name}
                />
              </div>

              <div className="form-group">
                <label>Biografie</label>
                <textarea
                  className="form-control"
                  onChange={(e) => setBio(e.target.value)}
                  value={bio}
                />
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};
